@if (viewType === viewTypes.LIST) {
<div
  [ngStyle]="{ maxHeight: containerHeight }"
  class="beneficiary-card-wrapper w-100"
  id="beneficiary-list"
  (scroll)="onScroll($event)"
>
  @for (beneficiary of beneficiaryData; track beneficiary?.id) {

  <finxone-web-frontend-list-item
    [textContentStyle]="contentStyle"
    [customHandlebarModel]="returnBeneficiaryHandleBarModel(beneficiary)"
    (itemClicked)="selectBeneficiary(beneficiary)"
    [content]="itemTemplate"
    [customClass]="'mb-5 pointer-events-none' + (isGlobalStylingEnabled ? ' global-list-styling' : '')"
    [gestures]="dataIn?.attri?.widgetProperties?.gestures"
    [listActions]="dataIn?.attri?.['listActions']"
    (actionTriggered)="onListSwipeAction($event, beneficiary)"
  ></finxone-web-frontend-list-item>
  }
</div>
} @if (viewType === viewTypes.TABLE) {
<finxone-web-frontend-desktop-listing
  [entityData]="beneficiaryData ?? []"
  [dataIn]="dataIn"
  [pageNumber]="pageNumber"
  (pageChange)="onPageChange($event)"
  [isApiInProgress]="isApiInProgress || appBuilderShowFetchingContent"
  [uniqueId]="'id'"
  (searchValueText)="searchValue($event)"
  [menuPopupCss]="menuPopupCss"
  [enableClickableRow]="true"
  [actionOptions]="actionOptions"
  [isShowMoreOption]="(actionOptions?.length || 0) > 0"
  [isShowOption]="false"
  [totalListCount]="totalListCount"
  (rowData)="selectBeneficiary($event)"
  (performAction)="performAction($event)"
  (actionEvent)="handleAction($event)"
></finxone-web-frontend-desktop-listing>
}
